/* ---- BUNDLE GRID: 96 FRAMES, NOT 48 ----
   The builder renders one page of the range at a time. That page was 48,
   which on the 25 KD range means 48 of 728 — so all but the first page
   depended on a shopper pressing "Show more", and best-selling order then
   kept the same frames on top of the pile indefinitely.

   WHY 96 IS SAFE, AND WHY IT IS NOT UNLIMITED. Picking a frame rebuilds the
   whole grid, so the page size is a responsiveness budget, not a display
   preference. Measured on the live page: 48 cards rebuild in 17ms, 96 in
   31ms. An earlier version rendered the entire range and the rebuild was
   slow enough that the next tap did nothing — that is the failure this
   number exists to avoid, so it is doubled, not removed.

   WHY IT EXPANDS RATHER THAN SETTING THE NUMBER. bundleShown lives inside
   the closure in sf-claude.js and cannot be reached from outside. But
   showMoreBundles IS published on SF, and one call moves 48 to 96. So this
   presses it once, on the shopper's behalf, as soon as the first page has
   rendered.

   IT RE-ARMS ON EVERY TIER CHANGE, because setTier resets the count back to
   48. Without that, switching from 2-for-40 to 3-for-55 would quietly drop
   back to half a page — the kind of fault that looks like it works.

   THE GUARD IS THE SHOW-MORE BUTTON ITSELF. It expands only while that
   button is visible, which is the builder's own statement that more frames
   exist. A filter narrowing the range to fewer than 96 hides the button, so
   nothing is pressed and there is no loop.
*/
(function(){
"use strict";
var PAGES=1;           /* extra pages to open: 1 => 48 + 48 = 96 */
var opened=0, lastTier='';

function tierNow(){
  var t=document.querySelector('#bTabs .btab[aria-pressed="true"]');
  return t ? (t.textContent||'').trim() : '';
}
function canExpand(){
  var more=document.getElementById('bfMore');
  if(!more) return false;
  /* style.display is set to '' or 'none' by the renderer. */
  return more.style.display !== 'none';
}
function step(){
  if(!window.SF || typeof window.SF.showMoreBundles!=='function') return;
  var t=tierNow();
  if(t!==lastTier){ lastTier=t; opened=0 }      /* a new tier starts over */
  if(opened>=PAGES) return;
  if(!canExpand()) return;
  opened++;
  window.SF.showMoreBundles();
}
function watch(){
  var g=document.getElementById('bGrid');
  if(!g) return;
  var queued=false;
  new MutationObserver(function(){
    if(queued) return;
    queued=true;
    requestAnimationFrame(function(){ queued=false; step() });
  }).observe(g, {childList:true});
  step();
}
if(document.readyState==='complete') watch();
else window.addEventListener('load', watch);
})();
